
export const headerStyles = {
  display: 'inline-block',
  fontWeight: '300',
  fontSize: '1.75em'
};
